import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    standalone: true,
    name: "todayOrOtherDate",
})
export class TodayOrOtherDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    transform(value: Date | null | undefined): string {
        if(!value){
            return "";
        }

        let dateToFormat: Date = new Date(value);

        const today = new Date();
        const isToday = today.toDateString() === dateToFormat.toDateString();

        // If today, return format 'Today, h:mm a'
        if (isToday) {
            return this.datePipe.transform(dateToFormat, "h:mm a") as string;
        }

        // Otherwise, return format 'MMM d, y, h:mm a'
        return this.datePipe.transform(dateToFormat, "MMM d, h:mm a") || "";
    }
}
